<template>
    <AutomationDesignerDashboard v-if="isReady" :automation="automation" @updateAutomation="updateAutomation" />
    <CbDashboardProgressBar v-else :isReady="isReady" text="Automation Loading" />
</template>

<script>
import AutomationDesignerDashboard from "./diagram/AutomationDesignerDashboard.vue";
import log2 from "../../../../../utils/log2";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import Vue from "vue";
import VAnimateCss from "v-animate-css";
import CbDashboardProgressBar from "../../../Chatbot/pages/dashboard/common/CbDashboardProgressBar.vue";
import { AUTOMATION_API } from "../../../../../api/automation";
import StringUtils from "../../../../../utils/StringUtils";

Vue.use(VAnimateCss);
const log = log2("AutomationPlannerPage");

export default {
    name: "AutomationPlannerPage",
    components: {
        AutomationDesignerDashboard,
        CbDashboardProgressBar,
    },
    computed: {
        ...mapGetters({}),
        ...mapState({
            currentAutomation: (state) => state.automation.current,
        }),
    },
    methods: {
        ...mapActions({
            getStory: "CB/getStory",
        }),
        ...mapMutations({
            setCurrentAutomation: "automation/setCurrentAutomation",
        }),
        updateAutomation(automation) {
            this.automation = automation;
        },
    },
    data() {
        return {
            automationId: window.location.pathname.split("/")[2],
            isReady: false,
            automation: {},
        };
    },

    beforeMount() {},
    mounted() {
        log("mounted ", {
            automationId: this.automationId,
        });
        const filters = [
            {
                key: "_id",
                value: this.automationId,
                operator: "equals",
            },
        ];
        const startTS = Date.now();
        AUTOMATION_API.listAutomations(filters).then((data) => {
            const { items } = data;
            if (items.length > 0) {
                this.automation = items[0];
            }
            const tookTime = Date.now() - startTS;
            if (tookTime < 1000) {
                setTimeout(() => {
                    this.isReady = true;
                }, 1000 - tookTime);
            } else {
                this.isReady = true;
            }
        });
    },
    watch: {
        automation: {
            handler: function (automation) {
                const isEqual = StringUtils.hashCodeObj(automation) === StringUtils.hashCodeObj(this.currentAutomation);
                if (!isEqual) {
                    console.log("currentAutomation changed from inside");
                    this.setCurrentAutomation(automation);
                }
            },
            deep: true,
        },
        currentAutomation: {
            handler: function (automation) {
                const isEqual = StringUtils.hashCodeObj(automation) === StringUtils.hashCodeObj(this.automation);
                if (!isEqual) {
                    console.log("currentAutomation changed from outside");
                    this.automation = automation;
                }
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.ant-popover.no-padding {
    .ant-popover-inner-content {
        padding: 0 !important;
    }
}
</style>
